module.exports = __webpack_public_path__ + "static/img/7.b27ba32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/7.png
// module id = QdDI
// module chunks = 0